import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import ProcessRequestExecutionState from '@app/model/process-request/ProcessRequestExecutionState';
import {
	FIND_LATEST_ACTIVE_PROCESS_REQUEST_EXECUTION_STATE_QUERY,
	FIND_PROCESS_REQUEST_EXECUTION_STATE_QUERY,
} from '@app/model/process-request/service/ProcessRequestGraphQLQueries';

class ProcessRequestService {
	public static async findLatestActiveProcessRequestExecutionState(): Promise<ProcessRequestExecutionState | null> {
		const result = await GraphQLExecutor.execute<ProcessRequestExecutionState | null>(
			FIND_LATEST_ACTIVE_PROCESS_REQUEST_EXECUTION_STATE_QUERY,
		);
		return result ? new ProcessRequestExecutionState(result) : null;
	}

	public static async findProcessRequestExecutionState(requestId: number): Promise<ProcessRequestExecutionState> {
		const result = await GraphQLExecutor.execute<ProcessRequestExecutionState | null>(
			FIND_PROCESS_REQUEST_EXECUTION_STATE_QUERY,
			{ requestId },
		);
		if (!result) {
			throw new Error(`Process request ${requestId} could not be found`);
		}
		return new ProcessRequestExecutionState(result);
	}
}

export default ProcessRequestService;
